import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Cidade {
  _id;
  nome;
  ibge_code;
  estado_id;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {String} data.nome
   * @param {Number} data.ibge_code
   * @param {Number} data.estado
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.cidades.filter(
      x =>
        String(x.id) === String(this.id) ||
        (String(x.estado) === String(this.estado) &&
          String(x.nome) === String(this.nome)),
    );
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'cidades');
    return db.cidades.put(this);
  }

  static describe = () =>
    '++_id, nome, ibge_code, estado_id, createdAt, updatedAt, deletedAt';
}
